<div *ngIf="view == true" class="container">
  <mat-card *ngIf="activa == 0" style="background-color: #ffffff7a">
    <h2 style="display: flex; justify-content: center">
      <strong>Orden Combustible </strong>
    </h2>
    <h3>Número de orden: {{ bodyOrden.consecutive }}</h3>
    <h3>Equipo: {{ bodyOrden.code }}</h3>
    <h3>Fecha: {{ bodyOrden.date }}</h3>
    <h3>Lugar: {{ bodyOrden.place }}</h3>
    <h3>Tipo de Combustible: {{ bodyOrden.fuelType }}</h3>
    <h3>Odometro actual: {{ bodyOrden.currentOdometer }}</h3>
    <h3>Descripción: {{ bodyOrden.description }}</h3>
    <hr />
    <h3><strong>Quién autoriza</strong></h3>
    <h3>{{ bodyOrden.authorizeName }}</h3>

    <h5>Si ya se realizó, por favor cerrar la orden de combustible</h5>

    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 30px;
      "
    >
      <button
        style="width: 70%"
        color="warn"
        class="button-save mat-elevation-z5"
        mat-raised-button
        (click)="close()"
      >
        Cerrar Orden Combustible
      </button>
    </div>
  </mat-card>

  <mat-card *ngIf="activa == 1" style="background-color: #ffffff7a">
    <h2>
      <strong>Combustible para: {{ bodyOrden.code }} </strong>
    </h2>

    <form
      [formGroup]="formCloseOrder"
      (ngSubmit)="
        formCloseOrder.valid ? closeOrder(formCloseOrder.value) : errorMessage()
      "
    >
      <div class="first-row">
        <div class="row-item">
          <mat-form-field>
            <input
              (keyup)="calculatePrice()"
              autocomplete="off"
              type="number"
              matInput
              formControlName="gallons"
              #galones
              oninput="this.value = this.value.slice(0,8)"
              placeholder="Galones"
              required
            />
            <mat-hint>{{ galones.value.length }}/8</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              (keyup)="calculatePrice()"
              autocomplete="off"
              type="number"
              formControlName="gallonPrice"
              matInput
              #precio_galon
              oninput="this.value = this.value.slice(0,8)"
              placeholder="Precio por Galon"
              required
            />
            <mat-hint>{{ precio_galon.value.length }}/8</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="number"
              formControlName="totalPrice"
              matInput
              #precio_total
              oninput="this.value = this.value.slice(0,8)"
              placeholder="Precio Total"
              required
            />
            <mat-hint>{{ precio_total.value.length }}/8</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              formControlName="billNumber"
              matInput
              #numero_factura
              oninput="this.value = this.value.slice(0,100)"
              placeholder="Número de Factura"
              required
            />
            <mat-hint>{{ numero_factura.value.length }}/100</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              formControlName="salesOrder"
              matInput
              #orden_venta
              oninput="this.value = this.value.slice(0,100)"
              placeholder="Orden Venta"
              required
            />
            <mat-hint>{{ orden_venta.value.length }}/100</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="default-row" >
        <div class="row-item">
          <mat-form-field>
            <input
              type="number"
              autocomplete="off"
              formControlName="currentOdometer"
              matInput
              #odometro_actual
              oninput="this.value = this.value.slice(0,8)"
              placeholder="Odómetro/Horómetro"              
              required
            />
            <mat-hint>{{ odometro_actual.value.length }}/8</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: 30px;
        "
      >
        <button
          [disabled]="buttonActive"
          style="width: 60%"
          color="warn"
          class="button-save mat-elevation-z5"
          type="submit"
          mat-raised-button
        >
          Finalizar
        </button>
      </div>
    </form>
  </mat-card>
</div>
